exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".link-button {\n  border-radius: 5px;\n  background-color: #f10084;\n  color: #FFFFFF;\n  font-size: 15px;\n  font-weight: 700;\n  padding: 8px 10px;\n  text-decoration: none;\n}\n.link-button:hover {\n  color: #fff;\n  background-color: #e0007a;\n}", ""]);

// exports
